import React from 'react';
import { RiLoader4Line } from 'react-icons/ri';
import { useAuth } from './use-auth';

type ClerkLoadedProps = {
  children: React.ReactNode;
};

export function ClerkLoaded({ children }: ClerkLoadedProps) {
  const { isLoaded } = useAuth();

  if (!isLoaded) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="flex flex-col items-center gap-3">
          <RiLoader4Line className="text-primary-base size-8 animate-spin" />
          <div className="text-text-sub text-label-sm">Loading workspace...</div>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
